export default "__VITE_ASSET__BrVBOtEv__"